import { render, staticRenderFns } from "./wisdomClasscard.vue?vue&type=template&id=4913e3a4&scoped=true"
import script from "./wisdomClasscard.vue?vue&type=script&lang=js"
export * from "./wisdomClasscard.vue?vue&type=script&lang=js"
import style0 from "./wisdomClasscard.vue?vue&type=style&index=0&id=4913e3a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4913e3a4",
  null
  
)

export default component.exports